<template>
<div class="chapter">
<div class="inner_page">
<h1>Uncle Wiggily's funny auto</h1>
<div class="figcenter2" id="i002">
<img alt="Rabbit with wrench" class="w" id="id-3164269186516414514" src="Images/img0001.jpg"/></div>
<div class="chapter" id="calibre_pb_0">
<p class="calibre3"><span id="Page_4" title="[Pg 4]"></span></p>
<img alt="Empty car" class="w" id="id-2877434121656798078" src="Images/img0002.jpg"/>
</div>
<div>
<p class="calibre3">1. “This is too lovely weather to stay in the hollow stump bungalow,”
said Nurse Jane Fuzzy Wuzzy one day. “I’ll get Uncle Wiggily
to take me for a ride in his automobile.” Going to the door the muskrat
lady housekeeper called: “Wiggy! Oh, Wiggy! Where are you?<span style="text-indent: 1em;">”
But no answer came, though the car was in plain sight in the yard.
“I wonder if he has gone adventuring by himself?” said Nurse Jane.</span></p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_5" title="[Pg 5]"></span></p>
<div class="figcenter3" id="i005">
<img alt="Wiggily with wrench" class="w" id="id-6337157684933448248" src="Images/img0003.jpg"/>
</div>
<div>
<p class="calibre3">2. Once more the muskrat lady called. And then a voice, faint and
far off answered her: “What do you want?” The muskrat lady nearly
jumped out of her skin. “Where in the world are you, Wiggy?” she
asked. “I’d like you to take me for a ride.” Uncle Wiggily crawled
from beneath the machine. “I have been fixing the car so it would
ride faster and better,” he answered. “I’ll soon be ready for you.”</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_6" title="[Pg 6]"></span></p>
<div class="figcenter3" id="i006">
<img alt="Car with front wheels off the ground" class="w" id="id-8514561954538339210" src="Images/img0004.jpg"/>
</div>
<div>
<p class="calibre3">3. The rabbit gentleman washed himself clean of oil and black dirt,
and, dressed in his best suit, he started to take Nurse Jane for a ride.
“Maybe we’ll have some adventures,” spoke the muskrat lady. At
first the auto ran along very easily. But, all of a sudden, it reared
up on its hind wheels like a skittish horse and began moving backward.
“Oh, Uncle Wiggily, what did you do to it?” cried Nurse Jane.</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_7" title="[Pg 7]"></span></p>
<div class="figcenter3" id="i007">
<img alt="Car on right two wheels" class="w" id="id-8398848170375242251" src="Images/img0005.jpg"/>
</div>
<div>
<p class="calibre3">4. “I didn’t do anything to the auto except fix it,” said Uncle Wiggily.
“Yes, you fixed it all right!” cried Nurse Jane. And just then
the car settled down on all four wheels and began to race around a
tree like playing Ring in the Rosie game. “Oh, what is going to happen
now?” squeaked Miss Fuzzy Wuzzy. Uncle Wiggily held her in
as the car skidded on two wheels. “Don’t jump!” shouted the rabbit.</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_8" title="[Pg 8]"></span></p>
<div class="figcenter3" id="i008">
<img alt="Car on front two wheels" class="w" id="id-429553603002218785" src="Images/img0006.jpg"/>
</div>
<div>
<p class="calibre3">5. Uncle Wiggily twisted this way and that way on the steering
wheel, and finally the auto stopped skidding around the tree. “Now
I guess we are all right,” laughed the bunny rabbit. “Anyhow, you
wanted some adventures, Nurse Jane, and you are getting them.”
Miss Fuzzy Wuzzy sniffed. “Yes, I’m getting them all right,” she said.
“Oh, what’s it doing now?” she cried, as the auto tilted up again.</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_9" title="[Pg 9]"></span></p>
<div class="figcenter3" id="i009">
<img alt="Alligator chasing car" class="w" id="id-5869210961464793966" src="Images/img0007.jpg"/>
</div>
<div>
<p class="calibre3">6. By hard work, Uncle Wiggily saved Nurse Jane from falling out
of the car. And by speaking kind words to the machine, and by putting
a little talcum powder on the radiator, the rabbit gentleman at last
got his auto to settle down and jog along as it should do. But, all
of a sudden, as Nurse Jane looked back, wondering how many miles
they had come, she saw the Skillery Skallery Alligator. Oh my!</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_10" title="[Pg 10]"></span></p>
<div class="figcenter3" id="i010">
<img alt="Car speeding along with alligator behind" class="w" id="id-3729561584934716001" src="Images/img0008.jpg"/>
</div>
<div>
<p class="calibre3">7. “Ho! Ho!” bellowed the Alligator, opening wide his big mouth.
“I shall soon have some fine ear-nibbles.” Then he flipped his tail and
he flapped his tail and after Uncle Wiggily’s auto the Alligator ran.
“Oh, go fast! Go fast, Uncle Wiggily!” cried Nurse Jane. So the
rabbit uncle made his car go as fast as he could. “I hope it plays
no more tricks,” thought Uncle Wiggily. “If it does, we are lost!”</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_11" title="[Pg 11]"></span></p>
<div class="figcenter3" id="i011">
<img alt="Car chasing alligator" class="w" id="id-2058662539758107731" src="Images/img0009.jpg"/>
</div>
<div>
<p class="calibre3">8. All of a sudden, when the Alligator had almost caught Uncle
Wiggily and Nurse Jane, the auto gave a shiver and a shake. “Oh, it’s
going to cut up some more tricks!” cried the rabbit. “Come, Nurse
Jane, we’ll get on the back seat.” And, no sooner were they safe on
the back seat than the automobile turned around, all by itself, and
began to chase the Alligator. “Now it is my turn!” honked the auto.</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_12" title="[Pg 12]"></span></p>
<div class="figcenter3" id="i012">
<img alt="Car hits alligator" class="w" id="id-6073315839541875827" src="Images/img0010.jpg"/>
</div>
<div>
<p class="calibre3">9. Faster and faster the auto ran after the Alligator. “Ha! Ha!”
laughed Nurse Jane. “I wonder how the Skillery Skallery chap likes
being chased? Keep on, Auto!” And the auto kept on, until, all of a
sudden, it reached the Alligator, and, bumping the bad chap with the
front wheels, sent the ’Gator flying over the trees. “Ah, now I can
faint safely,” sighed Nurse Jane. And the Squiggle Bugs danced.</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_13" title="[Pg 13]"></span></p>
<p class="center3">And if the cream puff doesn’t jump into the pickle jar to hide away from the<br class="calibre5"/>
chocolate cake when they’re playing tag, the next<br class="calibre5"/>
pictures and story will tell how</p>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><br class="calibre5"/>
</p>
<div class="figcenter2" id="i013">
<img alt="Wolf standing in snow" class="w" id="id-8675585912129796445" src="Images/img0011.jpg"/>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="center3">UNCLE WIGGILY WITH HIS SNOW PLOW, A<br class="calibre5"/>
KINDNESS TRIED TO DO. THE FOX AND WOLF WERE<br class="calibre5"/>
VERY MEAN. THAT’S WHAT I THINK; DON’T YOU? I HOPE SO!</p>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_14" title="[Pg 14]"></span></p>
<div class="figcenter3" id="i014">
<img alt="Pigs pulling snow plow" class="w" id="id-8052162068021984963" src="Images/img0012.jpg"/>
</div>
<div>
<p class="calibre3">1. One day, after a heavy fall of snow, Uncle Wiggily got out his
snow plow, and, with Curly and Floppy Twistytail, started to plow a
path around the hollow stump bungalow. “Now Nurse Jane can get
out and go to the three and four-cent store,” said the bunny. “I
know someone who can’t get out!” barked Jackie Bow Wow.
“Grandpa Goosey is snowed in!” The bunny said he’d plow him out.</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_15" title="[Pg 15]"></span></p>
<div class="figcenter3" id="i015">
<img alt="Pigs pulling snow plow fast" class="w" id="id-4842762028512264529" src="Images/img0013.jpg"/>
</div>
<div>
<p class="calibre3">2. “Come, boys!” called Uncle Wiggily to Curly and Floppy, when
he heard that his friend Grandfather Goosey Gander was snowed in.
“We must dig him out.” Off they started and the piggie boys went so
fast that they scattered a shower of snow on either side. “If anyone
was there,” grunted Curly, “we’d snow them under.” Floppy said that
was so. On they went, faster and faster to the pen of Grandpa Goosey.</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_16" title="[Pg 16]"></span></p>
<div class="figcenter3" id="i016">
<img alt="Wiggily and goose" class="w" id="id-16783517033718006" src="Images/img0014.jpg"/>
</div>
<div>
<p class="calibre3">3. Reaching the goose gentleman’s house, Uncle Wiggily saw that
it was all snowed in, for there had been a blizzard. “But we’ll soon
make a path for him!” cried Mr. Longears, twinkling his pink nose.
“Lively now, piggie boys!” Around the house they went with the
snow plow, Uncle Wiggily steering it. “Thank you for digging me
out!” quacked Grandpa. “Uncle Butter is next,” mewed Tommie Kat.</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_17" title="[Pg 17]"></span></p>
<div class="figcenter3" id="i017">
<img alt="Pigs with plow at goat house" class="w" id="id-4233621120648735959" src="Images/img0015.jpg"/>
</div>
<div>
<p class="calibre3">4. “What’s that?” cried Uncle Wiggily as he heard Tommie mewing.
“Your friend Uncle Butter, the goat, is also snowed up,” said Tommie.
“We must snow plow him out!” cried Uncle Wiggily. “Hurry, piggie
boys!” Very soon they came to a big wall of snow. Over the top
they saw a chimney. “Uncle Butter lives there,” said Curly. “But
our plow can never get through all that snow. What shall we do?”</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_18" title="[Pg 18]"></span></p>
<div class="figcenter3" id="i018">
<img alt="Goat flying through snow" class="w" id="id-6345860794717519126" src="Images/img0016.jpg"/>
</div>
<div>
<p class="calibre3">5. All of a sudden, as Uncle Wiggily and the piggie boys were wondering
how to get Uncle Butter out of his snow-drifted house, there
sounded a loud: “Baa-a-a-a-a!” Then through the snow wall came the
goat gentleman, head first. “How did you get out?” asked Uncle Wiggily,
as the goat flew over his head. “I lowered my horns and I butted
my way through the snow,” bleated the goat. “Now I’ll help you.”</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_19" title="[Pg 19]"></span></p>
<div class="figcenter3" id="i019">
<img alt="Goat and pigs pull snow plow" class="w" id="id-6453627324095625758" src="Images/img0017.jpg"/>
</div>
<div>
<p class="calibre3">6. After Uncle Butter burst his way through the snow, he helped the
piggies pull the snow plow, and they cleared a path around the goat’s
house. “We must dig out more of my friends,” said Uncle Wiggily.
Off they started again, and at last they came to two big heaps of
snow. “Hum!” said the bunny. “Some of my friends must live here,
though I can’t remember who they are. But I’ll plow them out.”</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_20" title="[Pg 20]"></span></p>
<div class="figcenter3" id="i020">
<img alt="Fox and wolf jump from snow mounds" class="w" id="id-7264768442375337212" src="Images/img0018.jpg"/>
</div>
<div>
<p class="calibre3">7. All of a sudden, just as Uncle Wiggily was going to plow around
the two snow mounds, to dig out those whom he thought were his
friends—all at once, from one mound burst the Fox, and from the
other the Wolf. “Ha! Ha!” snickered the bad chaps. “That’s the time
we fooled Uncle Wiggily. He thought we were his friends, but now we
can nibble his ears.” You can imagine how sad Uncle Wiggily felt.</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_21" title="[Pg 21]"></span></p>
<div class="figcenter3" id="i021">
<img alt="Snow plow covers wolf and fox" class="w" id="id-3786124373446113720" src="Images/img0019.jpg"/>
</div>
<div>
<p class="calibre3">8. Just as the Fox and Wolf jumped to catch Uncle Wiggily by the
ears, Uncle Butter bleated: “Come on, piggie boys! We’ll fool these
bad chaps. Come on! We’ll scatter snow over them and cover them up
again as they were at first. Then they can’t nibble us!” Off started the
goat gentleman and the piggie boys pulling Uncle Wiggily on the plow.
On either side shot out a stream of snow over the Fox and the Wolf.</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_22" title="[Pg 22]"></span></p>
<div class="figcenter3" id="i022">
<img alt="Goat and Wiggily wave hats" class="w" id="id-1332988922418327257" src="Images/img0020.jpg"/>
</div>
<div>
<p class="calibre3">9. “Oh wow!” howled the Fox, as he felt himself being snowed in
again. “Double-wow!” howled the Wolf. “And we get no ear nibbles
after all. It’s all your fault, for being so hasty, Mr. Fox!” Then the
Fox snarled and said: “’Tisn’t at all! It was your fault!” And there
they were, stuck back in snow drifts as before. And then the piggie
boys pulled Uncle Wiggily and Uncle Butter off on the snow plow.</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_23" title="[Pg 23]"></span></p>
<p class="center3">And if the jumping jack doesn’t try to ride the rocking horse around the dining<br class="calibre5"/>
room table and fall off and down into the salt cellar, the<br class="calibre5"/>
next pictures and story will tell how</p>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><br class="calibre5"/>
</p>
<div class="figcenter2" id="i023">
<img alt="Wiggily with water hose" class="w" id="id-5743026322147795581" src="Images/img0021.jpg"/>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="center3">UNCLE WIGGILY WATERS<br class="calibre5"/>
HIS GARDEN AND HIS NEIGHBORS, AND WHEN<br class="calibre5"/>
BUSHY BEAR CAME LUMBERING ALONG HE WAS WATERED TOO.</p>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_24" title="[Pg 24]"></span></p>
<div class="figcenter3" id="i024">
<img alt="Wiggily gets hose to water the garden" class="w" id="id-4817692177745495177" src="Images/img0022.jpg"/>
</div>
<div>
<p class="calibre3">1. There had been no rain in a long time, so Uncle Wiggily said:
“I will take the hose and water the garden.” Nurse Jane Fuzzy Wuzzy,
in the hollow stump bungalow, heard the bunny gentleman getting
ready to sprinkle. “Be careful,” she warned Uncle Wiggily. “Don’t
get wet and don’t splash any of the neighbors.” The bunny gave a jolly
laugh and said he guessed he knew how to handle a simple little hose.</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_25" title="[Pg 25]"></span></p>
<div class="figcenter3" id="i025">
<img alt="Wiggily looking at hose end" class="w" id="id-7479132062920531847" src="Images/img0023.jpg"/>
</div>
<div>
<p class="calibre3">2. Uncle Wiggily unwound the hose, fastened one end to the faucet
and then he turned the nozzle toward the garden, which was very
dry. But the water was a long time coming. “I wonder if the hose
can be stopped up?” thought Uncle Wiggily. “Water ought to be
spurting out by this time. I’ll look down the nozzle and see what’s
the matter. I certainly can’t wet my garden without some water.”</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_26" title="[Pg 26]"></span></p>
<div class="figcenter3" id="i026">
<img alt="Water sprays Wiggily" class="w" id="id-113295441561302752" src="Images/img0024.jpg"/>
</div>
<div>
<p class="calibre3">3. All of a sudden, when Uncle Wiggily was squinting down the
hose nozzle, the water quickly spurted out. Before the rabbit gentleman
could jump away he got his face full of water. “Oh, my goodness!”
exclaimed Mr. Longears. “I didn’t think it was going to do
that!” In the window of the bungalow Nurse Jane couldn’t help laughing.
“Didn’t I tell you to be careful, Wiggy, my dear!” she called out.</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_27" title="[Pg 27]"></span></p>
<div class="figcenter3" id="i027">
<img alt="Wiggily wrapped by hose" class="w" id="id-8578183487445502333" src="Images/img0025.jpg"/>
</div>
<div>
<p class="calibre3">4. Uncle Wiggily began to grow excited. He jumped about and tried
to pull the hose straight so he might water his garden, but the hose
kinked itself around one of his paws. “Oh my!” he cried. “I must be
very careful or I’ll fall and bump my pink nose.” The bunny danced
about, trying to get loose from the hose. But all the while the water
was spurting out, and, as he waved the nozzle, he scattered showers.</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_28" title="[Pg 28]"></span></p>
<div class="figcenter3" id="i028">
<img alt="Wiggily spraying himself" class="w" id="id-7425644913309470383" src="Images/img0026.jpg"/>
</div>
<div>
<p class="calibre3">5. At last Uncle Wiggily hopped out of the kinky loop of the hose,
and he was just going to start watering his garden when up rose Mrs.
Twistytail, the lady pig. “Look what you did to me, Uncle Wiggily!”
she cried, shaking her parasol at him. “I’m soaking wet!” And
the rabbit gentleman was so flustered that he stuck the hose straight
up in the air. Well—what goes up must come down, you know!</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_29" title="[Pg 29]"></span></p>
<div class="figcenter3" id="i029">
<img alt="Wiggily spraying water into house" class="w" id="id-2381078002350739399" src="Images/img0027.jpg"/>
</div>
<div>
<p class="calibre3">6. “I beg your pardon, Mrs. Twistytail! I really beg your pardon!”
exclaimed Uncle Wiggily. The pig lady grunted and waddled away to
get dry. Then the bunny noticed how wet he, himself, was. “Oh, I
must wring out my coat!” he exclaimed. He laid aside the hose for a
moment, but he never saw that he had pointed it at the open kitchen
window of his bungalow. “Swish!” went the water in the window.</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_30" title="[Pg 30]"></span></p>
<div class="figcenter3" id="i030">
<img alt="Wiggily spraying goat" class="w" id="id-6640593759028190454" src="Images/img0028.jpg"/>
</div>
<div>
<p class="calibre3">7. Nurse Jane was in the kitchen, baking a lollypop pie, and when
she felt the water coming in she rushed to the window and cried: “Oh,
stop it, Uncle Wiggily! Stop it!” The rabbit gentleman grew so
excited that he grabbed up the hose and, before he knew it he was
sprinkling Uncle Butter the goat. “Don’t wet me!” bleated Uncle
Butter. “Save the water for the bushy Bear! He’s coming along!”</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_31" title="[Pg 31]"></span></p>
<div class="figcenter3" id="i031">
<img alt="Bear coming" class="w" id="id-1491710436416616647" src="Images/img0029.jpg"/>
</div>
<div>
<p class="calibre3">8. “Oh, Uncle Butter! I beg your pardon, also!” cried Uncle Wiggily,
as he saw what he had done. “Never mind about begging pardons,”
bleated the goat. “Get ready for the Bear. He’s right behind
me!” And, surely enough, the Bushy Bear came lumbering around
the corner of the hollow stump bungalow. “Give me some ear
nibbles!” he growled. “Give him the hose!” cried Uncle Butter.</p>
</div>
<p class="calibre3"><br class="calibre5"/>
</p>
<p class="calibre3"><span id="Page_32" title="[Pg 32]"></span></p>
<div class="figcenter3" id="i032">
<img alt="Wiggily sprays bear" class="w" id="id-7867200627159013875" src="Images/img0030.jpg"/>
</div>
<div>
<p class="calibre3">9. “Ha! That’s a good idea!” exclaimed the bunny as the Bear
made a rush for him. “Good morning, Mr. Bear!” went on Mr. Longears,
politely. “Have you washed your face today? If you haven’t
I’ll wash it for you!” And with that he sozzled the Bear good. “Ha!
Ha!” laughed Uncle Butter. “Do you want any ears to nibble?” The
Bear flopped a somersault, growling: “This is too much! I’ll be good!”</p>
</div>
<div class="figcenter4" id="i033"><div class="caption"><div class="blockquot">
</div>
</div>
</div>
<p>THE END.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?5a326c0a